import { updatePortfolioValueVisibilityAction } from "@/app/actions/portfolio/portfolio-actions";
import { Button } from "@/components/ui/button";
import { FormItem } from "@/components/ui/form";
import { PortfolioEditQuery } from "@/hooks/queries/portfolio/use-portfolio-edit-query";
import { EyeClosedIcon, EyeOpenIcon } from "@radix-ui/react-icons";

interface Props {
  readonly portfolioId: string;
  readonly isValueVisible: boolean;
   
  readonly optimisticFn?: (action: boolean) => void;
  readonly path: string | null;
}

export function PortfolioValueVisibility(props: Props) {
  const updatePortfolioVisibilityAction = async () => {
    props.optimisticFn?.(!props.isValueVisible);
    const res = await updatePortfolioValueVisibilityAction(
      props.portfolioId,
      !props.isValueVisible,
      props.path ?? "/",
    );

    if (res.success) {
      PortfolioEditQuery.invalidate(props.portfolioId);
    }
  };

  return (
    <form action={updatePortfolioVisibilityAction}>
      <FormItem id="portfolio-value-visibility">
        <Button variant="ghost" className="m-0 p-0 px-2">
          {props.isValueVisible ? (
            <EyeOpenIcon className="size-4" />
          ) : (
            <EyeClosedIcon className="size-4" />
          )}
        </Button>
      </FormItem>
    </form>
  );
}
